/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pesticide_TitleInputs */

const vi_pesticide_title = /** @type {(inputs: Pesticide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thuốc bảo vệ thực vật`)
};

/**

* @param {Pesticide_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pesticide_title = /** @type {((inputs?: Pesticide_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pesticide_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pesticide_title(inputs)
});